import { localeReducer as locale } from "data/reducers/locale";
import { reducer as notifications } from "lib/api/notifications";
import { combineReducers } from "redux";

export const rootReducer = combineReducers({
  // app-specific reducers:
  // rwgps api reducers:
  notifications,
  locale,
});
